import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import IrisPage from 'yoda-site-components/lib/components/IrisPage/IrisPage';
import irisComponentsForHome from 'yoda-site-components/lib/iris/components/forHome';
import ScrollTop from 'yoda-site-components/lib/components/ScrollTop/ScrollTop';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { hotdealsPostProcessor } from 'yoda-interfaces/lib/IrisPage/IrisPage';
import _get from 'lodash/get';
import renderMiniPDP from '../../../helper/MiniPDPHelper';
import { onPageReady } from '../../../actions/HomePageAction';

const defaultPreferences = {};

/* istanbul ignore next */
export class HomePage extends PureComponent {
    static defaultProps = {
        actions: {},
        irisData: {},
        location: {},
        isPreview: false,
        irisFallbackPreferences: {},
        irisFallbackEnabled: false,
        disableIrisCall: false,
    };

    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        irisData: PropTypes.objectOf(
            PropTypes.oneOfType([
                PropTypes.object,
                PropTypes.string,
                PropTypes.number,
                PropTypes.bool,
            ])
        ),
        location: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
        isPreview: PropTypes.bool,
        irisFallbackEnabled: PropTypes.bool,
        irisFallbackPreferences: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
            .isRequired,
        disableIrisCall: PropTypes.bool,
    };

    componentDidMount() {
        const { analytics } = this.props.irisData;
        if (analytics) {
            const { pageType, pageName } = analytics;
            this.props.actions.onPageReady(pageName, pageType);
        }
        LocalStorage.removeData('scrollToCartridge');
        LocalStorage.removeData('galleryScrollTo');
    }

    render() {
        let params = '/home';
        const { irisFallbackEnabled, irisFallbackPreferences, disableIrisCall } = this.props;
        if (this.props.isPreview) {
            const { location } = this.props;
            params = `/home${location.search}`;
        }
        const renderMiniPDPComponent = renderMiniPDP();
        return (
            <>
                <ScrollTop />
                <IrisPage
                    params={params}
                    pageType="HOME"
                    irisComponents={irisComponentsForHome}
                    irisFallbackEnabled={irisFallbackEnabled}
                    disableIrisCall={disableIrisCall}
                    irisFallbackPreferences={irisFallbackPreferences}
                    aggregateAPI
                    data-automation-id="home"
                    postProcessor={hotdealsPostProcessor}
                />
                {renderMiniPDPComponent}
            </>
        );
    }
}

const mapStateToProps = ({ irisData, context }) => ({
    irisData,
    isPreview: context.isPreview || false,
    irisFallbackPreferences: _get(
        context,
        'preferences.irisfallbackPreferences',
        defaultPreferences
    ),
    irisFallbackEnabled: _get(context, 'featureFlags.enableIrisFallback', false),
    disableIrisCall: _get(context, 'featureFlags.disableIrisCall', false),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            onPageReady,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
